import React from "react"

import { SimpleAudioPlayer } from "@/audio"

import type { RunRowLike } from "@/types/RunRow"

export const AudioCell = React.memo(({ item }: { item: RunRowLike }) => {
  if (!item.simulation_s3_bucket) {
    return null
  }

  return (
    // Fills the (already flex, overflow-clipping) table cell in normal flow. An
    // earlier absolute-inset layout relied on the HeroUI `td` being a positioning
    // context; the @coval/ui grid cell is not, so it would escape to the row.
    <div
      className="flex w-full min-w-0 items-center"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="min-w-0 flex-1">
        <SimpleAudioPlayer
          bucket={item.simulation_s3_bucket ?? ""}
          audioKey={item.simulation_s3_key ?? ""}
          compact
        />
      </div>
    </div>
  )
})
AudioCell.displayName = "AudioCell"
